import styled from 'styled-components';
import { Paper, minBp } from '@triumph/shared';
import Container from 'components/_utility/Container';

export const Outer = styled(Container)`
  position: sticky;
  top: 0;
  z-index: 10;
  padding: 0;

  @media ${minBp('desktop')} {
    padding: 0 20px;
  }
`;

export const Wrap = styled(Paper)`
  margin-bottom: 31px;

  @media ${minBp('desktop')} {
    margin-bottom: 28px;
  }
`;
